/* jshint maxcomplexity: false */
/* jshint maxstatements: false */
/* jshint bitwise: false */
(function() {
	'use strict';

	angular.module('smb-app')
		.constant('SMB_SITE_ADMIN_GROUP', '&&_AIRBASE_SITE_ADMIN')
		.constant('SMB_RIGHTS_TYPE', {
			admin: 1,
			fullRights: 2,
			viewRights: 3,
			editRights: 4
		})
		.factory('SMB_RIGHTS', ['gettextCatalog', 'PX_PERMISSION_TYPE', 'SMB_SITE_ADMIN_GROUP', function(gettextCatalog, PX_PERMISSION_TYPE, SMB_SITE_ADMIN_GROUP) {
			return [
				{id: '', param: 0, name: ''},
				{id: 1, param: PX_PERMISSION_TYPE.FULLCONTROL, name: SMB_SITE_ADMIN_GROUP},
				{
					id: 2,
					param: PX_PERMISSION_TYPE.READ | PX_PERMISSION_TYPE.ADDDOC | PX_PERMISSION_TYPE.READDOC | PX_PERMISSION_TYPE.MODDOC | PX_PERMISSION_TYPE.DELDOC | PX_PERMISSION_TYPE.READFOLD | PX_PERMISSION_TYPE.MODFOLD | PX_PERMISSION_TYPE.DNLDDOC,
					name: gettextCatalog.getString('Full Rights')
				},
				{
					id: 3,
					param: PX_PERMISSION_TYPE.READ | PX_PERMISSION_TYPE.READDOC | PX_PERMISSION_TYPE.READFOLD,
					name: gettextCatalog.getString('View Rights')
				},
				{
					id: 4,
					param: PX_PERMISSION_TYPE.READ | PX_PERMISSION_TYPE.ADDDOC | PX_PERMISSION_TYPE.READDOC | PX_PERMISSION_TYPE.MODDOC | PX_PERMISSION_TYPE.READFOLD | PX_PERMISSION_TYPE.MODFOLD | PX_PERMISSION_TYPE.DNLDDOC,
					name: gettextCatalog.getString('Edit Rights')
				}
			];
		}])
		/**
		 * @ngdoc service
		 * @name smb-app.smbAclService
		 *
		 * @description
		 * A service for easily creating document groups based on the
		 * three different predefined access levels for document groups.
		 */
		.factory('smbAclService', [
			'$http',
			'$q',
			'pxUriPathService',
			'PX_PERMISSION_TYPE',
			'PX_ACL_CONST',
			'PX_OBJECT_TYPE',
			'SMB_RIGHTS_TYPE',
			'SMB_RIGHTS',
			'SMB_SITE_ADMIN_GROUP',
			AclService
		]);

	function AclService(
		$http,
		$q,
		pxUriPathService,
		PX_PERMISSION_TYPE,
		PX_ACL_CONST,
		PX_OBJECT_TYPE,
		SMB_RIGHTS_TYPE,
		SMB_RIGHTS,
		SMB_SITE_ADMIN_GROUP
	) {

		/**
		 * @description
		 * An object that represents a single user group's access level to
		 * a single document group.
		 *
		 * @param {any} right The access rights for the document group and user group
		 * @param {any} objectType The object type; can be document, document group, or document type. Almost always library.
		 * @param {any} objectId The id of the object; typically the document group id.
		 * @param {any} userGroup The user group the access rights are for.
		 */
		function Acl(right, objectType, objectId, userGroup) {
			this._right = right;
			this._objectType = objectType;
			this._objectId = objectId;
			this._userGroup = userGroup;
		}

		/**
		 * @description
		 * Returns true if the acl represents admin rights to the given object.
		 *
		 * @returns {Boolean} True if the acl represents admin rights and false otherwise.
		 */
		Acl.prototype.hasAdminAccess = function hasAdminAccess() {
			return this._right.id === SMB_RIGHTS_TYPE.admin;
		};

		/**
		 * @description
		 * Returns true if the acl represents full access rights to the given object.
		 *
		 * @returns {Boolean} True if the acl represents full access rights and false otherwise.
		 */
		Acl.prototype.hasFullAccess = function hasFullAccess() {
			return this.hasAllPermissions(SMB_RIGHTS[SMB_RIGHTS_TYPE.fullRights].param);
		};

		/**
		 * @description
		 * Returns true if the acl represents view access rights to the given object
		 *
		 * @returns {Boolean} True if the acl represents view access rights and false otherwise.
		 */
		Acl.prototype.hasViewAccess = function hasViewAccess() {
			return this.hasAllPermissions(SMB_RIGHTS[SMB_RIGHTS_TYPE.viewRights].param);
		};

		/**
		 * @description
		 * Returns true if the acl represents edit access rights to the given object.
		 */
		Acl.prototype.hasEditAccess = function hasEditAccess() {
			return this.hasAllPermissions(SMB_RIGHTS[SMB_RIGHTS_TYPE.editRights].param);
		};

		/**
		 * Check if the ACL has all of the specified permissions.
		 *
		 * @param {number} perm The permissions to check against the acl.
		 * @returns {boolean} True if the instance has access to all given permissions and false otherwise.
		 */
		Acl.prototype.hasAllPermissions = function hasAllPermissions(perm) {
			return (this._right.param & perm) === perm;
		};

		/**
		 * @description
		 * Creates an object that represents the acl type expected by the Phoenix API.
		 *
		 * @returns {Object} An ACL object that is compatible with the Phoenix API.
		 */
		Acl.prototype.toServerAcl = function() {
			var serverAcl = {
				RoleName: null,
				UserGroupId: this._userGroup.UserGroupId,
				UserGroupName: this._userGroup.UserGroupName,
				Embedded: { Permissions: [] }
			};

			switch (this._objectType) {
				case PX_OBJECT_TYPE.DOCUMENT:
					serverAcl.DocumentId = this._objectId;
					break;
				case PX_OBJECT_TYPE.FOLDER:
					serverAcl.FolderId = this._objectId;
					break;
				case PX_OBJECT_TYPE.LIBRARY:
					serverAcl.LibraryId = this._objectId;
					break;
			}

			var permissionVal = PX_PERMISSION_TYPE.FULLCONTROL;
			while (permissionVal < PX_ACL_CONST.MaxPermission) {
				var newPerm = {
					PermissionValue: permissionVal,
					Allow: false,
					Deny: false
				};

				if (this._right.id === SMB_RIGHTS_TYPE.admin) {
					newPerm.Allow = permissionVal === PX_PERMISSION_TYPE.FULLCONTROL;
				} else if (this._right.id === SMB_RIGHTS_TYPE.fullRights) {
					newPerm.Allow = permissionVal === PX_PERMISSION_TYPE.READ ||
						permissionVal === PX_PERMISSION_TYPE.ADDDOC ||
						permissionVal === PX_PERMISSION_TYPE.MODDOC ||
						permissionVal === PX_PERMISSION_TYPE.READDOC ||
						permissionVal === PX_PERMISSION_TYPE.DELDOC ||
						permissionVal === PX_PERMISSION_TYPE.READFOLD ||
						permissionVal === PX_PERMISSION_TYPE.DNLDDOC ||
						permissionVal === PX_PERMISSION_TYPE.MODFOLD;
				} else if (this._right.id === SMB_RIGHTS_TYPE.viewRights) {
					newPerm.Allow = permissionVal === PX_PERMISSION_TYPE.READ ||
						permissionVal === PX_PERMISSION_TYPE.READDOC ||
						permissionVal === PX_PERMISSION_TYPE.READFOLD;
				} else if (this._right.id === SMB_RIGHTS_TYPE.editRights) {
					var x = this._right.param & permissionVal;
					newPerm.Allow = x === permissionVal;
				}

				serverAcl.Embedded.Permissions.push(newPerm);

				if (permissionVal < 0) {
					permissionVal = 1;
				} else {
					/* jshint -W016 */
					permissionVal <<= 1;
					/* jshint +W016 */
				}
			}

			return serverAcl;
		};

		Object.defineProperties(Acl.prototype, {
			'objectId': {
				configurable: false,
				enumerable: true,
				get: function() { return this._objectId; }
			}
		});

		/**
		 * @description
		 * A factory method that creates an Acl instance from a Phoenix API representation
		 * of an ACL.
		 *
		 * @param {Object} serverAcl A Phoenix API ACL object.
		 *
		 * @returns {Acl} An Acl instance that represents the API acl.
		 */
		Acl.fromServerAcl = function fromServerAcl(serverAcl) {
			var rights = SMB_RIGHTS.find(function(r) {
				return r.param === serverAcl.Privileges;
			});

			if (!rights) {
				return;
			}

			return new Acl(rights, serverAcl.LibraryId, {
				UserGroupId: serverAcl.UserGroupId,
				UserGroupName: serverAcl.UserGroupName
			});
		};

		return {
			/**
			 * @ngdoc method
			 * @name smbAclService#createAdminRights
			 * @methodOf smb-app.smbAclService
			 * @kind function
			 *
			 * @description
			 * Creates and admin level acl for a document group
			 *
			 * @param {ObjectId} documentGroupId The document group to create the acl for
			 * @param {ObjectId} userGroupId Id of the admin user group.
			 *
			 * @returns {Acl} An instance of @see Acl
			 */
			createAdminRights: createAdminRights,

			/**
			 * @ngdoc method
			 * @name smbAclService#createFullAccessRights
			 * @methodOf smb-app.smbAclService
			 * @kind function
			 *
			 * @description
			 * Creates a full access level acl for a specific document group
			 *
			 * @param {ObjectId} documentGroupId The document group to create the acl for
			 * @param {Object} userGroup The user group to create the ACL for
			 */
			createFullAccessRights: createFullAccessRights,

			/**
			 * @ngdoc method
			 * @name smbAclService#createViewAccessRights
			 * @methodOf smb-app.smbAclService
			 * @kind function
			 *
			 * @description
			 * Creates a view access acl for a specific document group
			 *
			 * @param {ObjectId} documentGroupId The document group id to create the acl for
			 * @param {Object} userGroup The user group to create the acl for
			 */
			createViewAccessRights: createViewAccessRights,

			createEditAccessRights: createEditAccessRights,

			/**
			 * @ngdoc method
			 * @name smbAclService#saveDocumentGroupAcls
			 * @methodOf smb-app.smbAclService
			 * @kind function
			 *
			 * @description
			 * Save a list of Acl objects for a specific document group.
			 *
			 * @param {ObjectId} documentGroupId The id of the document group to save the acls to
			 * @param {Acl[]} acls An array of Acl objects.
			 *
			 * @returns {Promise<Acl[]>} An object that resolves to an array of the Acl objects
			 * that were just saved.
			 */
			saveDocumentGroupAcls: saveDocumentGroupAcls,

			/**
			 * @ngdoc method
			 * @name smbAclService#getUserPermissionsForDocumentGroup
			 * @methodOf smb-app.smbAclService
			 * @kind function
			 *
			 * @description
			 * Gets the current user's permission for a document group.
			 *
			 * @param {ObjectId} documentGroupId The id of the document group whose user permissions are being retrieved.
			 *
			 * @returns {Promise<Acl>} A promise that resolves to an Acl object.
			 */
			getUserPermissionsForDocumentGroup: getUserPermissionsForDocumentGroup,

			/**
			 * @ngdoc method
			 * @name smbAclService#getUserPermissionsForDocumentType
			 * @methodOf smb-app.smbAclService
			 * @kind function
			 *
			 * @description
			 * Gets the current user's permission for a document type.
			 *
			 * @param {ObjectId} documentTypeId The id of the document type whose user permissions are being retrieved.
			 *
			 * @returns {Promise<Acl>} A promise that resolves to an Acl object.
			 */
			getUserPermissionsForDocumentType: getUserPermissionsForDocumentType
		};

		function createAdminRights(documentGroupId, userGroupId) {
			return new Acl(SMB_RIGHTS[SMB_RIGHTS_TYPE.admin], PX_OBJECT_TYPE.LIBRARY, documentGroupId, {
				UserGroupId: userGroupId,
				UserGroupName: SMB_SITE_ADMIN_GROUP
			});
		}

		function createFullAccessRights(documentGroupId, userGroup) {
			return new Acl(SMB_RIGHTS[SMB_RIGHTS_TYPE.fullRights], PX_OBJECT_TYPE.LIBRARY, documentGroupId, userGroup);
		}

		function createViewAccessRights(documentGroupId, userGroup) {
			return new Acl(SMB_RIGHTS[SMB_RIGHTS_TYPE.viewRights], PX_OBJECT_TYPE.LIBRARY, documentGroupId, userGroup);
		}

		function createEditAccessRights(documentGroupId, userGroup) {
			return new Acl(SMB_RIGHTS[SMB_RIGHTS_TYPE.editRights], PX_OBJECT_TYPE.LIBRARY, documentGroupId, userGroup);
		}

		function saveDocumentGroupAcls(documentGroupId, acls) {
			var url = pxUriPathService.resolvePath('/libraries/' + documentGroupId + '/permissions/replace');
			acls = acls.map(function(acl) { return acl.toServerAcl(); });
			return $http.post(url, acls)
				.then(function() { return acls; });
		}

		function getUserPermissionsForDocumentGroup(documentGroupId) {
			var url = '/libraries/' + documentGroupId + '/permissionsforuser';
			return $http.get(pxUriPathService.resolvePath(url))
				.then(function(res) { return res.data; })
				.then(getAclWithMostAccess)
				.then(Acl.fromServerAcl);
		}

		function getUserPermissionsForDocumentType(documentTypeId) {
			var url = '/f/' + documentTypeId + '/permissionsforuser';
			return $http.get(pxUriPathService.resolvePath(url))
				.then(function(res) { return res.data; })
				.then(getAclWithMostAccess)
				.then(Acl.fromServerAcl);
		}

		function getAclWithMostAccess(acls) {
			return acls.reduce(function(prev, curr) {
				var cmp = cmpAcl(prev, curr);
				return cmp <= 0 ? prev : curr;
			});
		}

		function cmpAcl(acl1, acl2) {
			return acl2.Privileges - acl1.Privileges;
		}

		function filterOwnerAcl(acl) {
			return acl.RoleName !== 'Owner';
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/services/aclService.js
// module id = 134
// module chunks = 1